import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { canAccessProduction } from "../lib/roles";
import { DARK } from "./seedance/constants";

// RL2 — guard de las superficies de PRODUCCIÓN (Projects, VFX Keyframes, Orca
// Lab, VFX Autopilot, Ingest, Scores). Espeja AdminRoute pero admite
// admin+supervisor (misma política que el server: get_production_user). El rol
// `user` (editor) y `asist_edit` se redirigen a `/` — nunca ven ni cargan la
// superficie, así el fetch que reventaría con 403 ni se dispara.
export default function ProductionRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", background: DARK.bg, color: DARK.textDim,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'IBM Plex Sans','Helvetica Neue',sans-serif", fontSize: 13,
      }}>Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessProduction(user)) return <Navigate to="/" replace />;
  return children;
}
